<template>
  <div class="page">
    <PcHeader></PcHeader>
    <div class="strong1">
      <div :class="[!isMobile?'qrcode-wrap':'qrcode-wrap-mobile']">
        <div class="qrcode"></div>
        <div class="font" v-if="!isMobile">立即扫码下载APP</div>
        <div class="font" v-else>长按二维码下载APP</div>
      </div>
    </div>
    <div class="strong2"></div>
    <div class="strong3"></div>
    <div class="strong4" v-if="!isMobile"></div>
    <div class="strong5" v-if="!isMobile"></div>
    <div class="strong6"></div>
    <Footer :isMobile="isMobile"></Footer>
    <!-- <div class="footer">
      <div class="code"></div>
      <div class="font" v-if="!isMobile">立即扫码下载APP</div>
      <div class="font" v-else>长按二维码下载APP</div>
      <div class="copy-message">
        <div class="copy">欢迎登录益盟官方网站www.emoney.cn &nbsp;投资有风险,入市需谨慎</div>
        <div class="tips">
          本页面内容最终解释权归益盟股份有限公司&nbsp;沪ICP备06000340
          <a
            href="http://www.emoney.cn/dianjin/abby/2013_1_kq/index.html"
          >风险提示</a>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import PcHeader from '@/components/PcHeader'
import Footer from '@/components/Footer'

export default {
  data() {
    return {
      isMobile: /android|micromessenger|ipad|iphone|mac/i.test(
        navigator.userAgent
      )
    }
  },
  components: {
    PcHeader,
    Footer
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.footer {
  overflow: hidden;
  height: 370px;
  background-color: #333;
  color: #999;
  .code {
    width: 130px;
    height: 130px;
    margin: 50px auto 0;
    background: url('./images/qrcode.png') no-repeat;
    background-size: 100%;
  }
  .font {
    color: #fff;
    font-size: 22px;
    margin-top: 15px;
  }
  .copy-message {
    font-size: 18px;
    padding: 40px 20px 0;
    > div {
      margin-top: 10px;
    }
  }
}
.strong1 {
  position: relative;
  // height: 530px;
  padding-bottom: 530/1920 * 100%;
  background: url('./images/strong1.png') no-repeat;
  background-size: cover;
  .qrcode-wrap {
    position: absolute;
    left: 31%;
    bottom: 7%;
    width: 8%;
    padding-bottom: 8%;
    .qrcode {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding-bottom: 100%;

      background: url('./images/qrcode.png') no-repeat;
      background-size: 100%;
      margin: 0 auto;
    }
    .font {
      position: absolute;
      left: -10.5%;
      bottom: -18%;
      width: 120%;
      font-size: 56%;
      font-weight: bold;
      white-space: nowrap;
    }
  }
}
.strong2 {
  position: relative;
  padding-bottom: 500/1920 * 100%;
  background: url('./images/strong2.png') no-repeat;
  background-size: cover;
}
.strong3 {
  position: relative;
  padding-bottom: 500/1920 * 100%;
  background: url('./images/strong3.png') no-repeat;
  background-size: cover;
}
.strong4 {
  position: relative;
  padding-bottom: 500/1920 * 100%;
  background: url('./images/strong4.png') no-repeat;
  background-size: cover;
}
.strong5 {
  position: relative;
  padding-bottom: 500/1920 * 100%;
  background: url('./images/strong5.png') no-repeat;
  background-size: cover;
}
.strong6 {
  position: relative;
  padding-bottom: 400/1920 * 100%;
  background: url('./images/strong6.png') no-repeat;
  background-size: cover;
}
.mobile {
  .strong1 {
    position: relative;
    height: 406px;
    background: url('./images/ms1.png') no-repeat;
    background-size: cover;
    .qrcode-wrap-mobile {
      position: absolute;
      left: 7%;
      bottom: 3%;
      .qrcode {
        width: 100px;
        height: 100px;
        background: url('./images/qrcode.png') no-repeat;
        background-size: 100%;
        margin: 0 auto;
      }
      .font {
        font-size: 20px;
        margin-top: 8px;
        white-space: nowrap;
      }
    }
  }
  .strong2 {
    position: relative;
    padding-bottom: 764/750 * 100%;
    background: url('./images/ms2.png') no-repeat;
    background-size: cover;
  }
  .strong3 {
    position: relative;
    padding-bottom: 766/750 * 100%;
    background: url('./images/ms3.png') no-repeat;
    background-size: cover;
  }
  .strong6 {
    position: relative;
    padding-bottom: 305/750 * 100%;
    background: url('./images/ms4.png') no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/StrongEdition/StrongEdition.vue